"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ProgressBar = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const ProgressBarWrapper = (0, _mui.styled)('div')((param)=>{
    let { theme, ownerState } = param;
    return {
        position: 'relative',
        height: theme.spacing(1),
        marginTop: theme.spacing(3),
        marginRight: theme.spacing(3),
        borderRadius: theme.spacing(1),
        backgroundColor: theme.palette.grey[100],
        '&:after': {
            content: '""',
            position: 'absolute',
            background: ownerState.barColor,
            top: 0,
            bottom: 0,
            left: 0,
            width: ownerState.barLength,
            borderRadius: theme.spacing(1)
        },
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(6)
        }
    };
});
const ProgressValue = (0, _mui.styled)('div')((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(1),
        marginRight: theme.spacing(3),
        marginLeft: 'auto',
        fontSize: theme.typography.caption.fontSize,
        [theme.breakpoints.up('md')]: {
            marginRight: theme.spacing(6)
        }
    };
});
const ProgressAmount = (0, _mui.styled)('span')({
    fontWeight: 'bold'
});
const ProgressBar = (param)=>{
    let { progress, color } = param;
    const { target, amount, unit } = progress;
    const length = "".concat(Math.round(amount * 100 / target), "%");
    const ownerState = {
        barColor: color,
        barLength: length
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(ProgressBarWrapper, {
                ownerState: ownerState
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ProgressValue, {
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ProgressAmount, {
                        children: [
                            amount,
                            " / "
                        ]
                    }),
                    target,
                    " ",
                    unit ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(ProgressAmount, {
                        children: [
                            unit,
                            " "
                        ]
                    }) : null
                ]
            })
        ]
    });
};
exports.ProgressBar = ProgressBar;
